module.exports = __webpack_public_path__ + "img/home_icon.948bffa6.png";